<template>
  <v-card>
    <div class="pd-8">
      <v-data-table
        id="personGroupsTable"
        :headers="headers"
        :height="dataTableHeight"
        :items="getPersonGroups"
        :no-data-text="responseMessage"
        :loading-text="
          $t('fleet_management.entities.entities_table.labels.loading_text')
        "
        :loading="loading"
        item-key="id"
        sort-by="label"
        fixed-header
        :footer-props="{
          itemsPerPageText: 'Grupos por página',
          itemsPerPageOptions: itemsPerPageOptions,
          pageText: `${page} de ${totalPages}`
        }"
        :items-per-page.sync="itemsPerPage"
        :page.sync="page"
        @update:items-per-page="highlightSearchMatch()"
        @update:page="highlightSearchMatch()"
        @update:sort-by="highlightSearchMatch()"
        @update:sort-desc="highlightSearchMatch()"
      >
        <template v-slot:top>
          <div class="card--title">
            <v-toolbar height="57" rounded="lg" flat>
              <v-toolbar-title class="secondary--text"
                >{{
                  $t(
                    'fleet_management.person_groups.person_groups_table.person_groups_list'
                  )
                }}
                ({{ tagsLength }})</v-toolbar-title
              >
              <v-spacer></v-spacer>
              <v-btn
                v-if="isAdmin || isAdminSubFleet"
                text
                :to="{ name: 'person-group-create' }"
                id="idGruposDePersonasAgregar"
              >
                <v-icon class="tertiary--text pr-1"
                  >mdi-account-multiple-plus</v-icon
                >
                <span class="text-capitalize text-body-2">{{
                  $t(
                    'fleet_management.agents.data_table.labels.data_table_toolbar_button'
                  )
                }}</span>
              </v-btn>
            </v-toolbar>
          </div>
        </template>

        <!-- START HEADERS SLOTS -->
        <template v-slot:header.label="{ header }">
          <span class="ml-4" :id="header.id">{{ header.text }}</span>
        </template>
        <template v-slot:header.type="{ header }">
          <span class="ml-4">{{ header.text }}</span>
        </template>
        <!-- END OF HEADERS SLOTS -->

        <!-- START OF ITEMS SLOTS -->
        <template v-slot:item.label="{ item }">
          <v-chip
            class="searchable"
            outlined
            label
            :color="item.color"
            :style="{'cursor': isAdmin || isAdminSubFleet ? 'pointer' : 'default'}"
            @click="viewGroupDetail(item)"
          >
            <v-icon :color="item.color" left>
              mdi-account-group
            </v-icon>
            {{ item.label }}
          </v-chip>
        </template>
        <template v-slot:item.persons="{ item }">
          <v-menu
            top
            rounded-xl
            :open-on-hover="getPersonsByTag(item)"
            :open-on-click="false"
            transition="scale-transition"
            min-width="30px"
            allow-overflow
          >
            <template v-slot:activator="{ on }">
              <div v-on="on">
                <v-badge
                  :content="getPersonsByTag(item).length"
                  :value="getPersonsByTag(item).length"
                  color="tertiary"
                  overlap
                >
                  <SvgIcon
                    iconType="icon_person_groups"
                    :class="[
                      getPersonsByTag(item).length == 0 ? 'grey--text' : ''
                    ]"
                  />
                </v-badge>
              </div>
            </template>
            <v-card
              max-width="300"
              class="pl-2 scrollable-card"
              v-if="getPersonsByTag(item).length"
            >
              <v-chip-group column>
                <v-chip
                  v-for="thing in getPersonsByTag(item)"
                  :key="thing"
                  small
                >
                  {{ thing }}
                </v-chip>
              </v-chip-group>
            </v-card>
          </v-menu>
        </template>
        <template v-slot:item.actions="{ item, index }">
          <v-menu
            v-if="isAdmin || isAdminSubFleet"
            offset-x
            nudge-left="12"
            nudge-top="4"
            left
            rounded-xl
            content-class="white pa-1 v-menu__action-column"
          >
            <template v-slot:activator="{ on, attrs, value }">
              <v-btn
                :id="`idGruposDePersonasKebabMenu${index}`"
                :class="[value ? '' : 'btn__activator-not-focus']"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <div>
              <v-btn
                text
                @click="viewGroupDetail(item)"
                :id="`idGruposDePersonasVerDetalle${index}`"
              >
                <v-icon small color="secondary" class="mr-1">
                  mdi-information-outline
                </v-icon>
                <span class="text-body-2 text-capitalize">{{
                  $t('fleet_management.agents.data_table.labels.button_detail')
                }}</span>
              </v-btn>
              <v-btn
                v-if="isAdmin"
                @click="deleteGroup(item)"
                :id="`idGruposDePersonasEliminar${index}`"
                text
              >
                <v-icon small color="primary" class="mr-1">
                  mdi-trash-can-outline
                </v-icon>
                <span class="text-body-2 text-capitalize">{{
                  $t('fleet_management.agents.data_table.labels.button_delete')
                }}</span>
              </v-btn>
            </div>
          </v-menu>
        </template>
      </v-data-table>
      <v-snackbar
        v-model="snack"
        :color="snackColor"
        :timeout="snackBarTimeout"
      >
        {{ snackText }}
        <template v-slot:action="{ attrs }">
          <v-btn v-bind="attrs" text @click="snack = false">
            {{
              $t(
                'fleet_management.persons.person_info.labels.card_snackbar_close_button'
              )
            }}
          </v-btn>
        </template>
      </v-snackbar>
    </div>
    <Dialog
      :showDialog="showDialog"
      :text="dialog.text"
      :closeButtonText="dialog.closeButtonText"
      :submitButtonText="dialog.acceptButtonText"
      :oneButton="dialog.oneButtonDialog"
      :oneButtonText="dialog.oneButtonText"
      :type="dialog.type"
      :loading="dialog.loading"
      @cancelButtonPressed="cancelDialog"
      @submitButtonPressed="submitTagDelete"
      @oneButtonAction="cancelDialog"
    />
  </v-card>
</template>

<script>
import { i18n } from '@leapsight/portal'
import { mapActions, mapGetters } from 'vuex'
import store from '@/store'
import Mark from 'mark.js'
import { SvgIcon, SNACKBAR_TIMEOUT } from '@leapsight/styleguide'
import { TagsHelpers } from '@/helpers/mainExports'
import Dialog from '@/components/dialog/Dialog'

export default {
  name: 'TagsDataTable',
  components: { SvgIcon, Dialog },
  data() {
    return {
      snackBarTimeout: SNACKBAR_TIMEOUT,
      itemsPerPageOptions: [5, 10, 15],
      itemsPerPage: 10,
      page: 1,
      snackColor: '',
      snackText: '',
      snack: false,
      headers: [
        {
          text: i18n.t(
            'fleet_management.tags.tags_table.labels.data_table_header_label'
          ),
          align: 'center',
          value: 'label',
          class: 'secondary--text',
          id: 'idGruposDePersonasNombre'
        },
        {
          text: i18n.t(
            'fleet_management.person_groups.person_groups_table.labels.data_table_header_persons'
          ),
          align: 'center',
          value: 'persons',
          class: 'secondary--text',
          sortable: false
        },
        {
          text: '',
          value: 'actions',
          align: 'start',
          sortable: false
        }
      ],
      loading: false,
      searchMatch: [],
      markInstance: {},
      matchPosition: 1,
      dataTableHeight: 0,
      tagByPersons: {},
      tagToDelete: '',
      showDialog: false,
      dialogDefault: {
        text: '',
        closeButtonText: i18n.t('general.dialogComponent.closeButtonText'),
        acceptButtonText: i18n.t('general.dialogComponent.acceptButtonText'),
        type: '',
        loading: false,
        oneButtonText: '',
        oneButtonDialog: false
      },
      dialog: {
        text: '',
        closeButtonText: i18n.t('general.dialogComponent.closeButtonText'),
        acceptButtonText: i18n.t('general.dialogComponent.acceptButtonText'),
        type: '',
        loading: false,
        oneButtonText: '',
        oneButtonDialog: false
      },
      localTagsLength: 0
    }
  },
  computed: {
    ...mapGetters('tags', [
      'getPersonGroups',
      'getResponseError',
      'getResponseMessage'
    ]),
    ...mapGetters('auth', ['session']),
    ...mapGetters(['getSearchInput', 'getMatchPosition']),
    tagsLength() {
      return this.localTagsLength
    },
    isAdmin() {
      return store.getters.isAdmin
    },
    isAdminSubFleet() {
      return store.getters.isAdminSubFleet
    },
    responseMessage() {
      let message = ''
      if (this.getResponseError) {
        this.loading = false
        message = this.getResponseMessage
      } else {
        message = i18n.t(
          'fleet_management.person_groups.person_groups_table.no_data'
        )
      }
      return message
    },
    totalPages() {
      return Math.ceil(this.tagsLength / this.itemsPerPage)
    }
  },
  methods: {
    ...mapActions(['setSearchMatch']),
    ...mapActions('tags', [
      'cleanThingsState',
      'getTagsList',
      'deleteTag',
      'entitiesFind'
    ]),
    highlightSearchMatch() {
      setTimeout(() => {
        this.searchAndHighlight(this.getSearchInput)
      }, 5)
    },
    getPersonsByTag(item) {
      return this.tagByPersons[item.id] ?? []
    },
    viewGroupDetail(group) {
      if (this.isAdmin || this.isAdminSubFleet) {
        this.$router.push(`person-groups/${group.id}`)
      }
    },
    deleteGroup(item) {
      const { label } = item

      const hasPersons = this.getPersonsByTag(item).length > 0

      if (hasPersons) {
        this.dialog.oneButtonDialog = true
        this.showDialog = true
        this.dialog.text = i18n.t(
          'fleet_management.person_groups.person_group_info.errors.has_associations'
        )
        this.dialog.type = 'warning'
        this.dialog.oneButtonText = 'Aceptar'
        return
      }

      this.showDialog = true
      this.dialog.text = i18n.t(
        'fleet_management.person_groups.person_group_info.alerts.delete_group_dialog_text',
        { label }
      )
      this.dialog.type = 'warning'
      this.dialog.closeButtonText = i18n.t(
        'fleet_management.person_groups.person_group_info.delete_person_group.dialog_closeButton'
      )
      this.dialog.acceptButtonText = i18n.t(
        'fleet_management.person_groups.person_group_info.delete_person_group.dialog_acceptButton'
      )
      this.tagToDelete = item
    },
    cancelDialog() {
      this.showDialog = false
      Object.assign(this.dialog, this.dialogDefault)
    },
    async submitTagDelete() {
      const id = this.tagToDelete.id
      try {
        this.dialog.loading = true
        await TagsHelpers.deleteTag(id)
        this.dialog.loading = false
        this.dialog.type = 'success'
        this.dialog.text = i18n.t('general.dialogComponent.title_success')
        this.dialog.oneButtonDialog = true
        this.dialog.oneButtonText = i18n.t(
          'general.dialogComponent.acceptButtonText'
        )
        const allTags = await this.getTagsList()
        TagsHelpers.setTagsInLocalStorage(allTags)
        const personGroups = await this.getTagsList({ type: 'person' })
        this.localTagsLength = personGroups.length
      } catch (error) {
        const errorText = TagsHelpers.getErrorMessageByCode(error.error)
        this.dialog.loading = false
        this.dialog.type = 'error'
        this.dialog.text = errorText
        this.dialog.oneButtonDialog = true
        this.dialog.oneButtonText = i18n.t(
          'general.dialogComponent.acceptButtonText'
        )
      }
      this.page = 1
    },
    searchAndHighlight(inputTerm) {
      const keyword = inputTerm
      const marked = this.markInstance?.unmark ? this.markInstance : new Mark()
      const actualThis = this
      this.searchMatch = []

      marked.unmark({
        done: function() {
          marked.mark(keyword, {
            separateWordSearch: false,
            noMatch: function(term) {
              // Esta funcion se ejecuta cuando no hay match
            },
            each: function(node) {
              // Array con los row que machean a la busqueda
              actualThis.searchMatch.push(node.closest('tr'))
            }
          })
        }
      })

      this.setSearchMatch(this.searchMatch)
      // //Damos estilo al match activo si el listado de nodos encontrados es mayor a 0
      const activePosition = document.querySelectorAll('mark')

      if (activePosition.length > 0)
        activePosition[this.matchPosition - 1].classList.add('activeMatch')

      // // Scrollintoview para el match activo
      if (this.searchMatch.length > 0) {
        const selectedRow = this.searchMatch[this.matchPosition - 1]
        const dataTablelastRow = document.querySelector(
          '#personGroupsTable .v-data-table__wrapper table tbody tr:last-child'
        )
        const tableHeader = document.querySelector('.v-data-table-header')
          .clientHeight
        const barToScroll = document.querySelector(
          '#personGroupsTable .v-data-table__wrapper'
        )
        selectedRow.scrollIntoView()
        if (selectedRow === dataTablelastRow) {
          barToScroll.scrollBy({
            top: 0,
            behaviour: 'smooth'
          })
        } else {
          barToScroll.scrollBy({
            top: -tableHeader,
            behaviour: 'smooth'
          })
        }
      }
    },
    resize() {
      //each const represent an element, we calculate the avialiable size that the data-table can use
      const container = document.querySelector('.container.container--fluid')
        .offsetHeight
      const titleAndSearch = document.getElementById('titleAndSearch')
        .offsetHeight
      const tableHeader = document.querySelector('.card--title').offsetHeight
      const footer = document.querySelector('.v-footer').offsetHeight
      //viewPortHeight and we subtract the height of all the other elements
      const height = container - titleAndSearch - tableHeader - footer
      // 36 is the size of the padding that is not calculated before
      this.dataTableHeight = height - 36
    },
    async getEntitiesBySetRows() {
      const promisesPersonsByRows = []

      this.getPersonGroups.forEach(({ id }) => {
        promisesPersonsByRows.push(
          this.entitiesFind({ tagId: id, projection: 'person' })
        )
      })

      try {
        const result = await Promise.allSettled(promisesPersonsByRows)

        const personsByRows = result.map(result => {
          const { value } = result
          return value
        })

        personsByRows.forEach(({ tagId, result }) => {
          this.tagByPersons[tagId] = result.map(item => Object.values(item)[0])
        })
      } catch (e) {
        console.log(e)
        this.snackText = this.getResponseMessage
        this.snackColor = 'error'
        this.snack = true
      }
    }
  },
  mounted() {
    addEventListener('resize', this.resize)
    this.$nextTick(function() {
      this.resize()
    })
  },
  destroyed() {
    removeEventListener('resize', this.resize)
  },
  watch: {
    getPersonGroups() {
      this.localTagsLength = this.getPersonGroups.length
    },
    getSearchInput() {
      const keyword = this.getSearchInput
      this.searchAndHighlight(keyword)
    },
    getMatchPosition() {
      this.matchPosition = this.getMatchPosition
      const keyword = this.getSearchInput
      this.searchAndHighlight(keyword)
    },
    session(newSession) {
      if (newSession.isOpen) {
        // timeout necesario para esperar a que termine de ejecutarse el personFetch al establecerse la conexión
        setTimeout(async () => {
          this.loading = true
          await this.getTagsList({ type: 'person' })
          await this.getEntitiesBySetRows()
          this.loading = false
        }, 1000)
      }
    }
  },
  async created() {
    this.loading = true
    this.cleanThingsState()
    if (this.session.isOpen) {
      await this.getTagsList({ type: 'person' })
      await this.getEntitiesBySetRows()
      this.loading = false
    }
  },
  updated() {
    this.$nextTick(function() {
      this.context = document.querySelectorAll('.searchable')
      this.markInstance = new Mark(this.context)
    })
  }
}
</script>

<style lang="scss" scoped>
mark {
  background-color: var(--yellow-lighten-1);
  &.activeMatch {
    background-color: var(--orange-ligthen-1);
  }
}

.scrollable-card {
  max-height: 200px;
  overflow-y: auto;
}
</style>
